import { DOCUMENT } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '@app/@core/services/language.service';
import { fade, slide, swipe } from '@app/animations';
import { I18nService } from '@app/i18n';
import { environment } from '@env/environment';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import {
  RegisterAccountData,
  UserPhoneNumber,
} from '@app/auth/authentication.service';
import { ContactInfo } from '@app/contact/contact.types';
import { ContactService } from '@app/contact/contact.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
  animations: [fade, slide, swipe],
  standalone: false,
})
export class CreateAccountComponent implements OnInit {
  @ViewChild('verifyOtp') verifyOtpComponent: VerifyOtpComponent;
  dir: string;
  version: string | null = environment.version;
  error: string | undefined;

  isLoading = false;
  phones: UserPhoneNumber[] = [];

  accountData: RegisterAccountData;
  currentLanguage: string;

  step = 1;
  country = environment.countrySettings.country;
  htmlTag: HTMLHtmlElement;
  contactInfo: ContactInfo;

  constructor(
    private i18nService: I18nService,
    private languageService: LanguageService,
    @Inject(DOCUMENT) private document: Document,
    private contactService: ContactService,
  ) {}

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.changeLanguageButtonText();
    // forcing the (rtl || ltr) direction in login component
    this.forceUpdateHtmlDirection();
    this.getSupportContact();
  }

  getSupportContact() {
    this.contactService
      .getContactsInfo()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res: ContactInfo) => {
          this.contactInfo = res;
        },
        (err) => {
          console.debug(err);
        },
      );
  }

  changeLanguageButtonText() {
    if (
      localStorage.getItem('language') &&
      localStorage.getItem('language') === 'ar'
    ) {
      this.currentLanguage = localStorage.getItem('language');
    }
  }

  changeLanguage(currentLanguage: string) {
    let targetedLanguage = currentLanguage;
    this.i18nService.language = targetedLanguage;
    this.languageService.language = targetedLanguage;
    this.languageService.changeHtmlDirection(targetedLanguage);
    location.reload();
  }

  forceUpdateHtmlDirection() {
    this.htmlTag = this.document.getElementsByTagName(
      'html',
    )[0] as HTMLHtmlElement;
    this.htmlTag.dir = localStorage.getItem('html-dir');
  }

  back(step: number) {
    this.step = step;
  }

  proceed(data: RegisterAccountData) {
    this.accountData = data;
    this.verifyOtpComponent.resendOtp(this.accountData, () => {
      this.step = 2;
    });
  }
}
